import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import extend from 'lodash/extend';

@Injectable()
export class CartEventsService {
  public _cartState: any = {
    isOpen: false,
    isStick: false
  };

  public cartState$ = new BehaviorSubject<any>(this._cartState);

  private _cartOpenClassName = 'cart-open';
  private _render: Renderer2;

  constructor(private _renderFactory: RendererFactory2) {
    this._render = this._renderFactory.createRenderer(null, null);
  }

  public showCart() {
    this._toggleCartOpenClass(true);
    this.cartState$.next(extend(this._cartState, { isOpen: true }));
  }

  public hideCart() {
    this._toggleCartOpenClass(false);
    this.cartState$.next(extend(this._cartState, { isOpen: false }));
  }

  public isCartClose(): boolean {
    return !this._cartState.isOpen;
  }

  public toggleCart() {
    const isOpen = !this._cartState.isOpen;
    this._toggleCartOpenClass(isOpen);
    this.cartState$.next(extend(this._cartState, { isOpen }));
  }

  private _toggleCartOpenClass(isOpen) {
    if (isOpen) {
      this._render.addClass(document.body, this._cartOpenClassName);
    } else {
      this._render.removeClass(document.body, this._cartOpenClassName);
    }
  }
}
